const DEFAULT_WIDTH = 1200;
const DEFAULT_HEIGHT = 900;
const screenWidth = window.innerWidth;
const screenHeight = window.innerHeight;
const scale = Math.min(screenWidth/DEFAULT_WIDTH,screenHeight/DEFAULT_HEIGHT);
export default class Score extends Phaser.GameObjects.Container {

    constructor(scene,screenHeight,scale) {
      super(scene);
      //scene.game.stage.backgroundColor = '#16a085';
      //Keep track of the users score
      scene.scoreTotal = 0;
      scene.scoreBuffer = 0;
      this.createScore(scene,screenHeight,scale);
    }

    createScore(scene,screenHeight,scale){
        var scoreFont = '120px "Grobold"';
        //Create the score label
        /*console.log("scene.game");
        console.log(scene.cameras);*/
        //const screenCenterX = scene.cameras.main.worldView.x + scene.cameras.main.width / 2;
        //const screenCenterY = scene.cameras.main.worldView.y + scene.cameras.main.height / 2;
        //scene.scoreLabel = scene.add.text(550, 140, "", {font:scoreFont, fill: "#FDE8CF", align:"center",boundsAlignH: "center", boundsAlignV: "middle"});
        scene.scoreLabel = scene.add.text((-screenWidth/scale)/2 + (967) + 440, 140, "", {font:scoreFont, fill: "#FDE8CF", align:"center",boundsAlignH: "center", boundsAlignV: "middle"});//position
        /* Positionnement en bas au milieu
        scene.scoreLabel = scene.add.text(scene.cameras.main.worldView.centerX, scene.cameras.main.worldView.bottom -50, "", {font:scoreFont, fill: "#FDE8CF", align:"center",boundsAlignH: "center", boundsAlignV: "middle"});
        */
        //scene.scoreLabel = scene.add.text(0, (screenHeight/scale)/2 - 50, "0", {font: scoreFont, fill: "#fff", stroke: "#535353", strokeThickness: 10,align:"center",boundsAlignH: "center", boundsAlignV: "middle"});
        //scene.scoreLabel.text = scene.scoreTotal ;
        scene.scoreLabel.setOrigin(0.5);
        //console.log(scene.scoreLabel);
        //scene.scoreLabel.anchor.setTo(0.5, 0);
        //scene.scoreLabel.align = 'center';
        //Create a tween to grow / shrink the score label
        //scene.scoreLabelTween = scene.add.tween(scene.scoreLabel.scale).to({ x: 1.5, y: 1.5}, 200, Phaser.Easing.Linear.In).to({ x: 1, y: 1}, 200, Phaser.Easing.Linear.In);
        scene.scoreLabelTween = scene.tweens.chain({
          targets: scene.scoreLabel,
          tweens: [
            {
              scale: 1.5,
              duration: 200, 
              ease: 'Linear',
            },
            {
              scale: 1,
              duration: 200, 
              ease: 'Linear',
            }
            
          ]
        });
        /*scene.scoreLabelTween = scene.tweens.add({
          targets: scene.scoreLabel,
          scale: 1.5,
          duration: 200, 
          ease: 'Linear',
        });*/
      }

  }